import { useState } from 'react'
import { ChevronRight } from 'lucide-react'

interface CollapsibleSectionProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}

export default function CollapsibleSection({ title, children, defaultOpen = true }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full px-6 py-4 flex items-center gap-2 hover:bg-gray-50 transition-colors cursor-pointer"
      >
        <ChevronRight className={`w-4 h-4 text-gray-400 transition-transform duration-150 ${open ? 'rotate-90' : ''}`} />
        <h3 className="text-sm font-medium text-gray-900">{title}</h3>
      </button>
      {open && children}
    </div>
  )
}
